if(!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.js-accordion-trigger');
      this.content = this.querySelector('.js-accordion-content');
      this.isOpen = true;
    }

    toggle() {
      if(this.isOpen) {
        this.isOpen = false;
        this.trigger.classList.remove('is-open');
        this.content.classList.remove('is-open');
        //this.content.style.height = `0px`;
        return;
      }

      this.isOpen = true;
      this.trigger.classList.add('is-open');
      this.content.classList.add('is-open');
      //this.content.style.height = `${this.contentHeight}px`;
      //this.content.style.height = this.contentHeight + 'px';
    }

    connectedCallback() {
      if(!this.trigger || !this.content) return;

      this.contentHeight = this.content.clientHeight;
      
      this.trigger.addEventListener('click', () => {
        this.toggle();
      });

      //this.content.style.height = `${this.contentHeight}px`;
      //this.content.style.height = this.contentHeight + 'px';
    }
  }

  customElements.define('accordion-item', AccordionItem);
}
